import {rawRenderingLib, RenderingServices} from '@wallaby-ui/core';
import classNames from 'classnames';
import styles from 'src/js/common/components/formatters/IconSpanWrapperLinkFormatter.less';
import stylesLinkFormatter from 'src/js/common/components/formatters/LinkFormatter.less';
import {HaidiSchema} from 'src/js/common/types';
import {getRouteAndIconName} from 'src/js/containers/encounter/encounter_helpers';
import {TemplatedCellRendererParams} from 'src/js/containers/grid/grid_types';
import {baseDashboardEncounterLinkFormatterParams} from 'src/js/lib/raw_rendering/base_dashboard_encounter_link_formatter_params';

import entityLinkRenderer from './entity_link_renderer';

/**
 * Returns raw DOM element version of EncounterLinkFormatter component.
 * @param params
 * @param services
 * @returns {Element}
 */

type Params = TemplatedCellRendererParams<HaidiSchema.components['schemas']['HaiDetailDto']>;

export function dashboardEncounterLinkFormatterFunction(params: Params, services: RenderingServices) {
  const {id, label, searchParams, titleText, encounterType} = baseDashboardEncounterLinkFormatterParams(params, services);
  const {iconName, route} = getRouteAndIconName(encounterType);

  const spanElem = document.createElement('span');
  spanElem.className = styles.dlSpanWrapper;

  if (iconName) {
    const iconElem = `<i class="${classNames(iconName, styles.dlIconLink)}" />`;
    rawRenderingLib.RawRenderingService.appendChildNodeOrHtml(spanElem, iconElem);
  }

  const divElem = document.createElement('div');
  divElem.className = stylesLinkFormatter.dlLinkFormatter;
  const textElem = rawRenderingLib.plainTextOrHtmlRenderer({
    showHtml: true,
    text: label,
    className: stylesLinkFormatter.dlLinkFormatterText,
  });
  const encounterLinkElem = entityLinkRenderer(
    {
      id,
      route,
      titleText,
      searchParams,
      suppressPadding: true,
      children: textElem,
    },
    services
  );
  rawRenderingLib.RawRenderingService.appendChildNodeOrHtml(divElem, encounterLinkElem);
  rawRenderingLib.RawRenderingService.appendChildNodeOrHtml(spanElem, divElem);

  return spanElem;
}
